import React, { useContext, useEffect, useState } from 'react'
import Heading from '../Heading'
import { motion } from "framer-motion";
import { shop } from '../../Data/E_Offer';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import {  message } from "antd";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';

import {Autoplay,Navigation} from 'swiper/modules'
import { UserDataContext } from '../../context/User';

const FeaturedProduct = () => {
   const { userData } = useContext(UserDataContext);
  const [products,setProducts]=useState([]);
  const isLoggedIn = userData?.id;
  const userTier = userData?.membershipTier?.key || "free"; // Assuming userData has a tier object with a key

  const [loading, setLoading] = useState(true);
  const [messageApi] = message.useMessage();

  const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                duration: 0.8
            }
        }
    };
    const navigate=useNavigate();
    const handleClick=(id)=>{
         console.log(id)
         navigate(`/detail/${id}`)
    }
    // Fetch Products
    useEffect(() => {
        const fetchGallery = async () => {
          try {
            setLoading(true);
            const response = await fetch("/api/products/fetch", {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            });
            const data = await response.json();
            console.log(data.data.colors);

            if (data.success) {
              setProducts(data.data);
            } else {
              messageApi.error("Failed to load gallery");
            }
          } catch (error) {
            console.error("Fetch error:", error);
            messageApi.error("Error loading gallery");
          } finally {
            setLoading(false);
          }
        };
        fetchGallery();
      }, [messageApi]);
    
  return (
      <motion.section 
            className="main-lwbl bg-[#F9FAFB] pt-16 pb-16 px-[0.5rem] overflow-hidden"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-50px" }}
            variants={containerVariants}
        >
           <Heading subHeading={"Featured Selections"}
             heading={<>Featured <br /> Products</>}
             detail={"These highlighted items represent the spirit of Lightweave Beacon Legacy—exceptional craftsmanship, meaningful storytelling, and direct creative impact."}
           />
             <div className=' h-[100%] w-[100%] relative md:px-12 md:py-12
             lg:px-16 lg:py-16  px-2 py-16' >
                <button className="swiper-prev custom-nav"><IoIosArrowBack /></button>
             <button className="swiper-next custom-nav"><IoIosArrowForward /></button>
           
                 <Swiper
                   slidesPerView={1}
                   spaceBetween={30}
                  loop={true}
                   autoplay={{
                        delay:1500,
                        disableOnInteraction: false,
                   }}
                   navigation={{
                 prevEl: ".swiper-prev",
                 nextEl: ".swiper-next",
               }}
                   breakpoints={{
               576: {
                 slidesPerView: 1,
                 spaceBetween: 20,
               },
               768: {
                 slidesPerView: 2,
                 spaceBetween: 20,
               },
               992: {
                 slidesPerView: 3,
                 spaceBetween: 20,
               },
               1200: {
                 slidesPerView: 4,
                 spaceBetween: 30,
               },
             }}
                   modules={[Autoplay, Navigation]}
                   className="mySwipers"
                 >
                  
                 {products.map((data,index)=>(
                    <SwiperSlide key={index}>
                    <div onClick={() => handleClick(data._id)} className='group cursor-pointer w-[100%] h-[460px]  text-center gap-[1rem] rounded-2xl'>
                        <img src={data.colors?.[0]?.images?.[0]} alt={data.title} style={{height:"85%", width:"100%", objectFit:"contain", borderRadius:"18px"}} />
                        <p className='font-cinzel text-[22px] mt-[1rem]'>{data.title}</p>
                    </div>
                    </SwiperSlide>
                ))}
                </Swiper>
                    </div>
           </motion.section>
  )
}

export default FeaturedProduct
